import { useEffect, useState } from "react";
import BottomTab from "../../components/common/bottom-tab";
import NoLikedStore from "../home/components/no-liked-store";
import Header from "../../components/common/header";
import ScrollRestore from "../../components/common/scroll-restore";
import { SkeletonWave } from "../../components/common/skeleton-wave";
import LikedStoreList from "./components/liked-store-list";
import { useLikedStores } from "./hooks/use-liked-stores";

const Like = () => {
  const [isRendered, setIsRendered] = useState(false);
  const {
    allStores,
    loading,
    initLoading,
    rootRef,
    loadMoreRef,
    hasMore,
    isLoadingMore,
    onClickStore,
    onClickLike,
  } = useLikedStores();

  useEffect(() => {
    if (allStores.length > 0) {
      setTimeout(() => setIsRendered(true), 0);
    } else {
      setIsRendered(false);
    }
  }, [allStores]);

  return (
    <div className="w-full h-[100vh] flex flex-col">
      <Header title="관심매장" />
      {allStores.length === 0 && !initLoading && !loading ? (
        <NoLikedStore />
      ) : null}
      <ScrollRestore
        ref={rootRef}
        id="scroll-like"
        className="pl-4 pr-4 mt-4 pb-16"
        initRestore={isRendered}
      >
        <div>
          {initLoading || loading ? (
            <SkeletonWave className="mb-4" />
          ) : (
            <LikedStoreList
              allStores={allStores}
              loading={loading}
              initLoading={initLoading}
              onClickStore={onClickStore}
              onClickLike={onClickLike}
            />
          )}
          {hasMore && !initLoading && !loading && allStores.length > 0 && (
            <div
              ref={loadMoreRef}
              className="flex justify-center items-center py-8 px-4"
            >
              {isLoadingMore && (
                <div className="flex items-center gap-2">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#1562fc]"></div>
                  <span className="text-gray-600 text-sm">불러오는 중...</span>
                </div>
              )}
            </div>
          )}
        </div>
      </ScrollRestore>
      <BottomTab />
    </div>
  );
};

export default Like;
